export function build2xResponsiveImage({ url, width, height, alt, lazy }) {
    const $image = document.createElement('img');

    if (lazy) {
        $image.loading = 'lazy';
    }

    $image.setAttribute('srcset', `${url}?w=${width} 1x, ${url}?w=${width * 2} 2x`);
    $image.setAttribute('alt', alt);
    $image.src = `${url}?w=${width}`;
    $image.width = width;
    $image.height = height;

    return $image;
}